var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('div', {
    staticClass: "client-content-wrap"
  }, [_c('section', {
    staticClass: "client-section"
  }, [_c('v-container', [_c('div', {
    staticClass: "section-title-wrap"
  }, [_c('h2', {
    staticClass: "client-title--xxxl"
  }, [_vm._v("위드캔복지재단")])])]), _c('v-img', {
    staticClass: "d-md-none",
    attrs: {
      "src": "/images/about/mobile-intro.jpg",
      "alt": ""
    }
  }), _c('div', {
    staticClass: "d-none d-md-block"
  }, [_c('v-card', {
    staticClass: "about-intro",
    attrs: {
      "tile": "",
      "flat": "",
      "img": "/images/about/about-intro.jpg"
    }
  }, [_c('v-container', {
    staticClass: "h-100 d-flex align-center"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-img', {
    attrs: {
      "max-width": "24",
      "src": "/images/about/quotes.svg",
      "alt": ""
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "client-title--lg font-weight-bold font-size-lg-36"
  }, [_vm._v(" 모두가 "), _c('span', {
    staticClass: "primary--text"
  }, [_vm._v("차별 없이")]), _vm._v(" "), _c('br'), _vm._v(" 기본적인 삶의 권리를 "), _c('br'), _vm._v(" 누릴 수 있도록, ")])]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "client-title--sm"
  }, [_vm._v(" 위드캔복지재단은 "), _c('br'), _vm._v(" 인간 존중과 전문성을 바탕으로 생애주기별 국내 전문 사회복지사업과 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 지속 가능한 발전 목표(SDGs)에 기반한 국제개발협력사업을 수행하는 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 글로벌 사회복지 NGO입니다. ")])])], 1)], 1)], 1)], 1)], 1), _c('section', {
    staticClass: "client-section pt-0"
  }, [_c('v-container', [_c('div', {
    staticClass: "section-title-wrap"
  }, [_c('h2', {
    staticClass: "tit tit--md"
  }, [_c('span', {
    staticClass: "primary--text"
  }, [_vm._v("1989년,")]), _vm._v(" 도움이 필요한 이웃과 함께하는 "), _c('span', {
    staticClass: "primary--text"
  }, [_vm._v("첫걸음")]), _vm._v("을 내딛었습니다")]), _c('p', {
    staticClass: "grey-1--text mt-18 mt-md-24"
  }, [_vm._v(" 우리는 인종, 종교, 사상, 지역의 경계를 넘어, 빈곤과 재난, 억압으로 고통받는 이웃들을 위해 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 사회복지를 실천하고 "), _c('strong', {
    staticClass: "primary--text"
  }, [_vm._v("지속 가능한 변화")]), _vm._v("를 만들어 갑니다. ")])]), _c('v-img', {
    staticClass: "border-radius-16",
    attrs: {
      "src": "/images/about/about.jpg",
      "alt": ""
    }
  })], 1)], 1), _c('section', {
    staticClass: "client-section pt-0"
  }, [_c('v-container', [_c('div', {
    staticClass: "section-title-wrap"
  }, [_c('h2', {
    staticClass: "tit tit--md"
  }, [_vm._v(" 위드캔복지재단은 국내와 해외에서 도움이 필요한 모든 이들에게 희망을 전하며, "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _c('span', {
    staticClass: "primary--text"
  }, [_vm._v("보다 나은 세상을 만들기 위해 앞으로도 함께 나아가겠습니다.")])])]), _c('div', {
    staticClass: "border-radius-16"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, _vm._l(_vm.purpose, function (item, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "12",
        "lg": "6"
      }
    }, [_c('v-card', {
      staticClass: "h-100 text-center",
      attrs: {
        "flat": "",
        "color": item.color
      }
    }, [_c('v-card-title', {
      staticClass: "justify-center pt-40 pb-lg-24"
    }, [_c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12"
      }
    }, [_c('div', {
      staticClass: "tit tit--md primary--text text--darken-2"
    }, [_vm._v(" " + _vm._s(item.title) + " ")])]), _c('v-col', {
      attrs: {
        "cols": "12"
      }
    }, [_c('div', {
      staticClass: "tit tit--sm grey-1--text"
    }, [_vm._v(" " + _vm._s(item.subtitle) + " ")])]), _c('v-col', {
      attrs: {
        "cols": "12"
      }
    }, [_c('v-row', {
      staticClass: "ma-n2",
      attrs: {
        "justify": "center"
      }
    }, _vm._l(3, function (dot) {
      return _c('v-col', {
        key: dot,
        staticClass: "pa-2",
        attrs: {
          "cols": "auto"
        }
      }, [_c('v-avatar', {
        attrs: {
          "size": "4",
          "color": "primary darken-2"
        }
      })], 1);
    }), 1)], 1)], 1)], 1), _c('v-card-text', {
      staticClass: "pb-40"
    }, [_c('p', {
      staticClass: "page-text page-text--lg grey-1--text",
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    })])], 1)], 1);
  }), 1)], 1)])], 1)]), _c('div', {
    staticClass: "client-content-wrap grey-fa"
  }, [_c('section', {
    staticClass: "client-section"
  }, [_c('v-container', [_c('div', {
    staticClass: "section-title-wrap"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("핵심역량")])]), _c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, _vm._l(_vm.capabilities, function (item, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "6",
        "md": "4",
        "lg": ""
      }
    }, [_c('v-card', {
      staticClass: "border-radius-16 h-100",
      attrs: {
        "flat": ""
      }
    }, [_c('v-card-title', {
      staticClass: "pt-lg-40"
    }, [_c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12"
      }
    }, [_c('v-img', {
      staticClass: "mx-auto",
      attrs: {
        "max-width": "80",
        "src": item.icon,
        "alt": ""
      }
    })], 1), _c('v-col', {
      attrs: {
        "cols": "12"
      }
    }, [_c('div', {
      staticClass: "tit tit--sm text-center primary--text text--darken-2"
    }, [_vm._v(" " + _vm._s(item.name) + " ")])])], 1)], 1), _c('v-card-text', {
      staticClass: "text-center pb-lg-40"
    }, [_c('p', {
      staticClass: "page-text page-text--lg",
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    })])], 1)], 1);
  }), 1)], 1)], 1)]), _c('div', {
    staticClass: "client-content-wrap"
  }, [_c('section', {
    staticClass: "client-section"
  }, [_c('v-container', [_c('div', {
    staticClass: "section-title-wrap mb-24 mb-lg-32"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("CI 소개")]), _c('p', {
    staticClass: "section-subtitle"
  }, [_vm._v(" 위드캔복지재단은 글로벌 NGO로서 협력과 돌봄을 실천하고, 사회적 약자의 권리를 옹호하며, "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 포용적 사회를 위한 네트워크를 구축하는 기관의 정체성을 반영한 표현입니다 ")])]), _c('v-row', {
    staticClass: "row--xxs",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "href": "/assets/ci/with-can.jpg",
      "download": "",
      "color": "#D5DAE3",
      "outlined": "",
      "rounded": "pill",
      "width": "160"
    }
  }, [_c('span', {
    staticClass: "button-text-color font-size-14"
  }, [_vm._v("JPG다운로드")]), _c('v-img', {
    staticClass: "ml-4",
    attrs: {
      "src": "/images/about/download.svg",
      "alt": "",
      "max-width": "16"
    }
  })], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "href": "/assets/ci/with-can.ai",
      "download": "",
      "color": "#D5DAE3",
      "outlined": "",
      "rounded": "pill",
      "width": "160"
    }
  }, [_c('span', {
    staticClass: "button-text-color font-size-14"
  }, [_vm._v("AI다운로드")]), _c('v-img', {
    staticClass: "ml-4",
    attrs: {
      "src": "/images/about/download.svg",
      "alt": "",
      "max-width": "16"
    }
  })], 1)], 1)], 1), _c('v-card', {
    staticClass: "ci-grid",
    attrs: {
      "color": "#B3B3B3",
      "outlined": "",
      "img": "/images/about/grid.jpg",
      "tile": "",
      "flat": ""
    }
  }, [_c('v-img', {
    staticClass: "mx-auto w-100",
    attrs: {
      "max-width": "438",
      "src": "/images/about/logo.svg",
      "alt": ""
    }
  })], 1), _c('v-row', {
    staticClass: "row--sm pt-30 pt-lg-40"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "tit tit--sm line-height-1"
  }, [_c('span', {
    staticClass: "primary--text"
  }, [_vm._v("WITH-")]), _c('span', {
    staticClass: "primary--text text--darken-2"
  }, [_vm._v("CAN")])])]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-divider')], 1), _vm._l(_vm.can, function (i) {
    return _c('v-col', {
      key: i.cap,
      attrs: {
        "cols": "12"
      }
    }, [_c('v-row', {
      attrs: {
        "align": "center",
        "no-gutters": ""
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "auto"
      }
    }, [_c('div', {
      staticClass: "tit tit--sm primary--text"
    }, [_vm._v(" " + _vm._s(i.cap) + " ")])]), _c('v-col', [_c('p', {
      staticClass: "page-text page-text--lg"
    }, [_vm._v(" " + _vm._s(i.txt) + " ")])])], 1)], 1);
  })], 2)], 1)], 1)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }